import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary/15 text-primary shadow-sm",
        secondary:
          "border-transparent bg-secondary/30 text-secondary-foreground",
        destructive:
          "border-transparent bg-coral-100 text-coral-700 shadow-sm dark:bg-coral-900/20 dark:text-coral-400",
        outline: "text-foreground border-border/50",
        success:
          "border-transparent bg-sage-100 text-sage-700 dark:bg-sage-900/20 dark:text-sage-400",
        warning:
          "border-transparent bg-coral-50 text-coral-600 dark:bg-coral-900/20 dark:text-coral-400",
        info:
          "border-transparent bg-teal-100 text-teal-700 dark:bg-teal-900/20 dark:text-teal-400",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
